import { buildProps, definePropType } from '@ll-plus/utils'

import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'

import type ColorPresetPicker from './color-preset-picker.vue'

// 定义组件props
export const colorPresetPickerProps = buildProps({
  colors: {
    type: definePropType<string[] | null>([Array, null]),
    default: () => null,
  },
  //
  value: {
    type: definePropType<string[] | string>([Array, String]),
    default: undefined,
  },
  // 多选
  multiple: {
    type: Boolean,
    default: false,
  },
  // 多选最多选中数量
  maxCount: {
    type: Number,
    default: 0,
  },
  // 形状
  shape: {
    type: definePropType<'square' | 'round'>(String),
    default: 'square',
  },
  // 间距
  gap: {
    type: Number,
    default: 10,
  },
  // 尺寸
  size: {
    type: String as () => SizeType,
  },
  // 只读
  readonly: {
    type: Boolean,
    default: false,
  },
} as const)

export const colorPresetPickerEmits = {
  change: (value: string | string[] | undefined) =>
    value === undefined ||
    typeof value === 'string' ||
    typeof value === 'object',

  'update:value': (value: string | string[] | undefined) =>
    value === undefined ||
    typeof value === 'string' ||
    typeof value === 'object',
} as const

// props
export type ColorPresetPickerProps = ExtractPropTypes<
  typeof colorPresetPickerProps
>

// emits
export type ColorPresetPickerEmits = typeof colorPresetPickerEmits

// instance
export type ColorPresetPickerInstance = InstanceType<typeof ColorPresetPicker>
